import React from 'react';
import './style.css';

class Aba extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
        
    }
  }
  render(){
    return <div>
        <p>
        Estou avançando no meu conhecimento de Level Design. <br/>
          Editores que eu sei usar: <br/>
          -Hammer Editor <br/>
          -CryEngine 2 Sandbox 2 <br/>
          -J.A.C.K. (Half-Life 1) <br/>
        </p>
    </div>
  };
}

export default Aba;